"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterChips = function FilterChips(_ref) {
  var intl = _ref.intl,
      data = _ref.data,
      onSelect = _ref.onSelect;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, data.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: value,
      className: "bg-gray-200 m-1 p-1 rounded inline-flex items-center text-base"
    }, label, /*#__PURE__*/_react["default"].createElement("span", {
      role: "button",
      tabIndex: 0,
      className: "ml-1 cursor-pointer",
      title: intl.formatMessage({
        id: 'filters.chips.reset'
      }),
      onClick: function onClick() {
        return onSelect(value);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterClose, {
      className: "h-4 w-4 fill-primary"
    })));
  }));
};

FilterChips.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    label: _propTypes["default"].node
  })),
  onSelect: _propTypes["default"].func
};

var noop = function noop() {};

FilterChips.defaultProps = {
  data: [],
  onSelect: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)(FilterChips);

exports["default"] = _default;